import { Image, Link } from "@nextui-org/react";
import React from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IoIosArrowBack } from "react-icons/io";
import logo from "../assets/images/homepage_logo.svg";

const AuthLayout = () => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full h-screen bg-white">
      <div className="w-full flex flex-col gap-y-8 items-center justify-between p-6">
        <div className="w-full max-w-lg flex space-x-1 items-center">
          <IoIosArrowBack className="text-gray-400" />
          <span className="text-sm text-gray-400">{t("Back to website")}</span>
        </div>
        <div className="w-full max-w-lg flex">
          <Outlet />
        </div>
        <div className="w-full max-w-lg flex space-x-2 items-center text-xs text-gray-400">
          © 2024 EasierLabs.{" "}
          {t("All Rights Reserved. Made with love by Adoptrs, designed by DesignSquad")} ® !
        </div>
      </div>
      <div className="w-full h-full bg-audio-gradient-bg bg-cover bg-center flex flex-col justify-center items-center space-y-12 rounded-bl-[8.5rem] px-6">
        <Image
          radius="none"
          alt="logo"
          src={logo}
          className="w-[580px] h-auto"
        />
        <div className="w-full max-w-sm flex flex-col space-y-1 items-center border border-white/20 rounded-2xl p-6">
          <p className="text-xs text-white/60">{t("Learn more about EasierLabs on")}</p>
          <Link
            href="https://easierlabs.ai"
            className="text-white text-sm"
          >
            easierlabs.ai
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
